/* unplugin-vue-components disabled */import { render } from "./SwpierTop.vue?vue&type=template&id=319577a1&scoped=true"
import script from "./SwpierTop.vue?vue&type=script&lang=js"
export * from "./SwpierTop.vue?vue&type=script&lang=js"

import "./SwpierTop.vue?vue&type=style&index=0&id=319577a1&lang=less&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-319577a1"]])

export default __exports__